import { Link } from "gatsby"
import React from "react"
import "./style.scss"
import Accordion from "react-bootstrap/Accordion"
import { useAccordionToggle } from "react-bootstrap/AccordionToggle"
import { FaAngleDown } from "react-icons/fa"

// import Logo from "../../images/logo_white.svg"
// import LinkedIn from "../../images/Icon-Linkedin.svg"
// import Fb from "../../images/Icon-FB.svg"
// import Twitter from "../../images/Icon-Twitter.svg"
// import Pinterest from "../../images/Icon-Pinterest.svg"
// import Instagram from "../../images/Icon-Instagram.svg"
// import Youtube from "../../images/Icon-Youtube.svg"
import LinkedIn from "../../images/footer/li_icon.png"
import Fb from "../../images/footer/fb_icon.png"
import Twitter from "../../images/footer/twt_icon.png"
import Pinterest from "../../images/footer/pin_icon.png"
import Instagram from "../../images/footer/insta_icon.png"
import Youtube from "../../images/footer/yt_icon.png"


const Toggle = ({ children, eventKey }) => {
  const decoratedOnClick = useAccordionToggle(eventKey, () =>
    console.log("clicked")
  )

  return (
    <button className="angle" onClick={decoratedOnClick}>
      {children}
    </button>
  )
}
// let iframe =
//   '<iframe width="540" height="130" src="https://7d5be48a.sibforms.com/serve/MUIEADbdKiKgs4Lj23LJTxS2ov5n1MNYU75o35CUz_-03aTGm88NEzdjUbTt18tmU7WCSvwKg-Hy7c4YAZdR66jJEztEJdVGCDK4GxJxp6SYQCIlXC97BlmsuiKINRy-i_PXU79CrTVsE9NLhyze_YJhpSc0p_V-nsUr9gj58KW4i15AwRhv2-4DkBm31OjaE2l97BxGMnqAKIe9" frameborder="0" scrolling="auto" allowfullscreen style="display: block;margin-left: auto;margin-right: auto;max-width: 100%;"></iframe>'
const Footer = ({ background }) => {
  const data = {
    address: [
      "Wersel Workdesk",
      <br />,
      "Level39, One Canada Square,",
      <br />,
      "Canary Wharf, London E14 5AB",
    ],
    socials: [
      {
        name: "fb",
        url: "https://www.facebook.com/werseldatahub",
        alt: "fb",
        src: Fb,
      },
      {
        name: "twitter",
        url: "https://twitter.com/wersel_workdesk",
        alt: "twitter",
        src: Twitter,
      },
      {
        name: "linkedin",
        url: "https://www.linkedin.com/company/werseldatahub/",
        alt: "linkedin",
        src: LinkedIn,
      },
      {
        name: "instagram",
        url: "https://instagram.com/werselworkdesk?igshid=YmMyMTA2M2Y=",
        alt: "instagram",
        src: Instagram,
      },
      {
        name: "youtube",
        url: "https://www.youtube.com/channel/UCVvHmczfgCqWi9CBSgWr8EQ",
        alt: "youtube",
        src: Youtube,
      },
      {
        name: "pinterest",
        url: "https://in.pinterest.com/werselworkdesk/",
        alt: "pinterest",
        src: Pinterest,
      },
    ],
  }
  const footerData = [
    {
      title: "Company",
      list: [
        { name: "About Us", url: "/our-story" },
        { name: "Jobs", url: "/careers" },
        { name: "Clients", url: "/#clients" },
        { name: "Write For Us", url: "/write-for-us" },
        { name: "Contact", url: "/contact" },
      ],
    },
    // {
    //   title: "Products",
    //   list: [
    //     { name: "Collaboration Platform", url: "/products/glassx/" },
    //     { name: "Enterprise Search Platform", url: "/products/discoverx/" },
    //     { name: "AI-Powered Product Data Platform", url: "/products/scoopx/" },
    //     {
    //       name: "AI-Powered Anti Counterfeit Tool",
    //       url: "/products/counterfeitx/",
    //     },
    //     { name: "Pricing Intelligence Platform", url: "/products/pricex/" },
    //     {
    //       name: "Product Recommendations Engine",
    //       url: "/products/prex/",
    //     },
    //     { name: "Business Intelligence Platform", url: "/products/dashx/" },
    //   ],
    // },
    // {
    //   title: "Solutions",
    //   list: [
    //     {
    //       name: "Mobile App Development",
    //       url: "/solutions/mobile-app-development-london/",
    //     },
    //     {
    //       name: "Animated Explanatory Videos",
    //       url: "/solutions/animated-video-production/",
    //     },
    //     {
    //       name: "A+ Page Development",
    //       url: "/solutions/wersel-product-page-optimization/",
    //     },
    //     { name: "Data As A Service", url: "/solutions/data-as-service/" },
    //     {
    //       name: "Data Visualization Service",
    //       url: "/solutions/data-visualization/",
    //     },
    //     {
    //       name: "Brand Protection Service",
    //       url: "/solutions/brand-protection/",
    //     },
    //     {
    //       name: "Marketplace Monitoring Service",
    //       url: "/solutions/marketplace-monitoring/",
    //     },
    //     { name: "Web Scraping Services", url: "/solutions/web-scraping/" },
    //     {
    //       name: "Data Advisory Services",
    //       url: "/solutions/data-advisory-service/",
    //     },
    //     {
    //       name: "Data Analytics Solutions",
    //       url: "/solutions/data-analytics-solutions/",
    //     },
    //   ],
    // },
    {
      title: "Features",
      list: [
        { name: "People & AI Analytics", url: "/people-AI-analytics/" },
        { name: "Data Management", url: "/data-management/" },
        { name: "Flexible Collaboration", url: "/flexible-collaboration/" },
        {
          name: "Enterprise Search",
          url: "/enterprise-search/",
        },
      ],
    },
    {
      title: "Benefits",
      list: [
        {
          name: "Circle of Trust",
          url: "/#benefits",
        },
        {
          name: "AI & Data Driven Enterprises",
          url: "/#benefits",
        },
      ],
    },
    {
      title: "Resources",
      list: [
        { name: "Blogs", url: "/blogs" },
        { name: "Videos", url: "/videos" },
        // { name: "White papers", url: "#/" },
        { name: "Ebooks", url: "/ebooks" },
        // { name: "Knowledge Base", url: "#/" },
        // { name: "FAQ", url: "#/" },
      ],
    },
    {
      title: "Policies",
      list: [
        { name: "Terms & Conditions", url: "/terms" },
        { name: "Privacy Policy", url: "/privacy-policy" },
        { name: "Cookies Policy", url: "/cookies-policy" },
        // { name: "GDPR Policy", url: "#/" },
      ],
    },
  ]
  const { address, socials } = data
  let socialsOne = socials.slice(0, 3)
  let socialsTwo = socials.slice(3)

  return (
    <footer
      className="template__footer"
      style={{ backgroundColor: background ? background : "#fcfcfc" }}
    >
      <div className="desktop">
        <div className="logo-area">
          <div className="site-logo">
            <img alt="logo" />
          </div>
          <div className="social-icons">
            <div>
              {socialsOne &&
                socialsOne.map((item, idx) => (
                  <a rel="noreferrer" target="_blank" key={idx} href={item.url}>
                    <img src={item.src} alt={item.alt} />
                  </a>
                ))}
            </div>
            <div>
              {socialsTwo &&
                socialsTwo.map((item, idx) => (
                  <a rel="noreferrer" target="_blank" key={idx} href={item.url}>
                    <img src={item.src} alt={item.alt} />
                  </a>
                ))}
            </div>
          </div>
          <p className="site-address">{address}</p>
        </div>
        {footerData &&
          footerData.map((list_item, index) => {
            return (
              <div className="footer-item" key={index}>
                <h1 className="title">{list_item && list_item.title}</h1>
                <ul>
                  {list_item.list &&
                    list_item.list.map((item, index) => {
                      return (
                        <li key={index}>
                          <Link to={item.url}>{item.name}</Link>
                        </li>
                      )
                    })}
                </ul>
              </div>
            )
          })}
      </div>
      <div className="mobile">
        {footerData &&
          footerData.map((item, index) => {
            return (
              <Accordion key={index} className="mobile-menu-accordion">
                <Toggle eventKey={index + 1}>
                  <div className="title-area d-flex flex-row align-items-center justify-content-between">
                    <p className="title">{item.title}</p>
                    <FaAngleDown />
                  </div>
                </Toggle>
                <Accordion.Collapse eventKey={index + 1}>
                  <ul>
                    {item.list &&
                      item.list.map((list_item, index) => {
                        return (
                          <li key={index}>
                            <Link to={list_item.url}>{list_item.name}</Link>
                          </li>
                        )
                      })}
                  </ul>
                </Accordion.Collapse>
              </Accordion>
            )
          })}
        <div className="logo-area">
          <div className="site-logo">
            <img alt="logo" />
          </div>
          <div className="social-icons">
            <div>
              <a target="_blank" href="https://www.facebook.com/werseldatahub" ><img src={Fb} alt="fb" /></a>
              <a target="_blank" href="https://twitter.com/wersel_workdesk" ><img src={Twitter} alt="twitter" /></a>
              <a target="_blank" href="https://www.linkedin.com/company/werseldatahub/" ><img src={LinkedIn} alt="linkedin" /></a>
            </div>
            <div>
            <a target="_blank" href="https://instagram.com/werselworkdesk?igshid=YmMyMTA2M2Y=" ><img src={Instagram} alt="instagram" /></a>
            <a target="_blank" href="https://www.youtube.com/channel/UCVvHmczfgCqWi9CBSgWr8EQ" ><img src={Youtube} alt="youtube" /></a>
            <a target="_blank" href="https://in.pinterest.com/werselworkdesk/" ><img src={Pinterest} alt="pinterest" /></a>
            </div>
            <div>
              <p className="site-address">{address}</p>
            </div>
          </div>
        </div>
      </div>
      {/* <EmailIframe iframe={iframe} /> */}
      <div className="copyright">
        <div>
          ©{new Date().getFullYear()}. Datinfi Pvt. Ltd. All rights
          reserved.
        </div>

        {/* <div>
          Marcus Data Consulting Limited is registered in England & Wales under
          company number 13684531.
        </div> */}
      </div>
    </footer>
  )
}

export default Footer
// const EmailIframe = ({ iframe }) => {
//   return <div dangerouslySetInnerHTML={{ __html: iframe ? iframe : "" }} />
// }
